import React, { useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useLocation } from "react-router-dom";
import { SessionService } from "../../services/authentication/sessionService";
import { StoreService } from "../../services/store/applicationStateService";
import Loader from "../../components/common/Loader/Loader";

function LoginSuccess() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // For query param
    const params = new URLSearchParams(location.search);
    const token = new URLSearchParams(location.hash.substring(1)).get("token");

    // For fragment/hash:
    // const token = new URLSearchParams(location.hash.substring(1)).get("token");

    if (token) {
      try {
        localStorage.setItem("jwtToken", token);
        SessionService.getSession().then((data) => {
          if (data) {
            StoreService.setStorage("firstName", data.firstName);
            StoreService.setStorage("lastName", data.lastName);
            StoreService.setStorage("Login Email", data.email);
            StoreService.setStorage("role", data.role);
            StoreService.setStorage("userId", data.userId);

            if (data.role === "Admin") {
              if (!data.planId) {
                navigate("/planselection");
              } else {
                navigate("/admin");
              }
            } else {
              navigate("/user");
            }
          }

        });
      }
      catch (error) {
      }
      // Redirect to main app/home      
    }
  }, [location, navigate]);

  return <Loader />;
}
export default LoginSuccess;